import styled from 'styled-components';

import { colors } from 'theme';

export const CurrencyInputContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  align-items: center;
`;

export const CurrencyInputSign = styled.span`
  position: absolute;
  z-index: 1;
  top: 12px;
  left: 18px;
  font-size: 18px;
  letter-spacing: 0;
  color: ${colors.lightContentGrey};
`;
